import React, { useState, useEffect } from 'react';
import ConfirmModal from 'shared/components/ConfirmModal';

const useConfirmModal = ({
  title,
  renderTitle,
  content,
  renderContent,
  confirmLabel,
  renderConfirmLabel,
  onConfirm,
  closeLabel,
  hasClose,
  onClose,
  rejectLabel,
  renderRejectLabel,
  onReject,
  size,
  noContentMargin,
  wrapperClassName,
}) => {
  const [opened, setOpened] = useState(false);
  const [state, setState] = useState({});
  const toggle = () => setOpened(prev => !prev);

  useEffect(() => {
    if (!opened) {
      setState({});
    }
  }, [opened]);

  const onConfirmClick = confirmLabel || renderConfirmLabel ? () => {
    if (onConfirm) {
      onConfirm(state);
    }
    setOpened(false);
  } : null;

  const onRejectClick = rejectLabel || renderRejectLabel ? () => {
    if (onReject) {
      onReject(state);
    }
    setOpened(false);
  } : null;

  const onCloseClick = () => {
    if (onClose) {
      onClose(state);
    }
    setOpened(false);
  };

  const close = () => setOpened(false);

  return {
    open(data = {}) {
      setState(data);
      setOpened(true);
    },
    close,
    toggle,
    setModalData: setState,
    modalComponent: (
      <ConfirmModal
        title={renderTitle ? renderTitle({ modalData: state, setModalData: setState, close }) : title}
        content={renderContent ? renderContent({ modalData: state, setModalData: setState, close }) : content}
        confirmLabel={renderConfirmLabel ? renderConfirmLabel(state) : confirmLabel}
        onConfirm={onConfirmClick}
        closeLabel={closeLabel}
        onClose={hasClose || onClose ? onCloseClick : undefined}
        rejectLabel={renderRejectLabel ? renderRejectLabel(state) : rejectLabel}
        onReject={onRejectClick}
        size={size}
        opened={opened}
        noContentMargin={noContentMargin}
        wrapperClassName={wrapperClassName}
      />
    )
  };
};

export default useConfirmModal;
